export default __webpack_public_path__ + "static/media/Animals_00.66e53bb8.png";